let CoinMatchConst = require("activity/CoinMatchActivity/CoinMatchConst")
let CoinMatchConfig = require("activity/CoinMatchActivity/CoinMatchConfig")
let ShareUtil = require("clover/utils/ShareUtil")

const ActivityStatus = CoinMatchConst.ActivityStatus
const AdType = CoinMatchConst.AdType

/**
 * 金币大冒险 逻辑
 */
let CoinMatchLogic = xClass("CoinMatchLogic")

const ICONMAP_FLAGNAME = "coinMatch";
const SETTING_OPEN_FLAGNAME = "showCoinMatchIcon";

// 行为枚举
const Action = {
    kShowIcon: 1,                   // 展示Icon
    kShowFinalReward: 2,            // 展示领最终奖励
    kShow: 3,                       // 展示活动  
    kShowQuesPanel: 4,              // 展示帮助界面
    kShowGetMoreStepPanel: 5,       // 展示获得更多步数界面
    kShowResetPanel: 6,             //展示重置框

    kGetFinalReward: 10,            // 获取最终奖励
    kReset: 11,                     // 重置
    kGetInviteReward: 12,           // 获取邀请奖励
    kInvite: 13,                    // 邀请
    kAd: 14,                        // 看广告加免费步数
    kPlayLevel: 15,                 // 玩关卡
    kShowOff: 16,                   // 炫耀
}

CoinMatchLogic.prototype.ctor = function () {
    this.manager = null;
    this.isActive = false;
    this.activeOnce = false;    // 是否尝试过激活

    this.actionMap = {
        [Action.kShowIcon]: false,
        [Action.kShowFinalReward]: false,
        [Action.kShow]: false,
        [Action.kShowQuesPanel]: false,
        [Action.kShowGetMoreStepPanel]: false,
        [Action.kShowResetPanel]: false,
        
        [Action.kGetFinalReward]: false,
        [Action.kReset]: false,
        [Action.kGetInviteReward]: false,
        [Action.kInvite]: false,
        [Action.kAd]: false,
        [Action.kPlayLevel]: false,
        [Action.kShowOff]: false,
    };
}

/**
 * 是否响应行为
 */
CoinMatchLogic.prototype.canResponse = function(action) {
    if (this.actionMap != null)
        return this.actionMap[action] == true;
}
/**
 * 将指定行为设为忙碌状态
 */
CoinMatchLogic.prototype.setBusy = function(action) {
    if (this.actionMap != null)
        this.actionMap[action] = false;
}
/**
 * 清除指定行为忙碌标志位
 */
CoinMatchLogic.prototype.resetBusy = function(action) {
    if (this.actionMap != null)
        this.actionMap[action] = true;
}

/**
 * 是否有活动相关内容
 */
CoinMatchLogic.prototype.canActive = function() {
    return UserManager.getInstance().canIconShow(ICONMAP_FLAGNAME) && this.getActivityStatus() != ActivityStatus.kUnopen;
}

/**
 * 激活
 */
CoinMatchLogic.prototype.active = function(onSuccess, onFail) {    
    if (this.isActive) {
        if (onSuccess != null)
            onSuccess();
        return;
    }
    
    this.manager = require("activity/CoinMatchActivity/CoinMatchManager").getInstance();    
    this.manager.active()
    .then(()=> {
        this.isActive = true;
        this.activeOnce = true;
        for(let key in this.actionMap) {
            this.actionMap[key] = true;
        }
        if (onSuccess != null)
            onSuccess();
    }).catch((err)=> {
        this.activeOnce = true;
        if (onFail != null)
            onFail();
    });
}

/**
 * 是否处于开放活动状态
 */
CoinMatchLogic.prototype.isOpen = function() {
    return this.getActivityStatus() == ActivityStatus.kOpen;
}

/**
 * 是否处于领奖阶段
 */
CoinMatchLogic.prototype.inRewardPeriod = function() {
    return this.getActivityStatus() == ActivityStatus.kReward;
}

/**
 * 获取活动状态：未开启；开启可以打关卡；关闭但可以领奖励
 */
CoinMatchLogic.prototype.getActivityStatus = function() {    
    let status = UserManager.getInstance().settings.data[SETTING_OPEN_FLAGNAME];
    if (status == null)
        status = ActivityStatus.kUnopen;
    return status;
}

/**
 * 是否可以展示Icon
 */
CoinMatchLogic.prototype.canShowIcon = function() {
    return this.isActive && 
        this.getActivityStatus() == ActivityStatus.kOpen ||
        (this.getActivityStatus() == ActivityStatus.kReward && this.manager.hasFinalReward())
}

/**
 * 展示首页Icon
 * @return isBusy
 */
CoinMatchLogic.prototype.showIcon = function() {
    if (!this.canResponse(Action.kShowIcon))
        return true;
    let self = this;
    this.setBusy(Action.kShowIcon);
        
    let homeScene = require("clover/scene/HomeScene").getInstance();
    if (homeScene.btnLayer && homeScene.btnLayer.coinMatchIcon == null) {
        let CoinMatchIcon = require("activity/CoinMatchActivity/CoinMatchIcon");
        let createIcon = () => {
            var hasAd = self.canGetMoreStepByAd();
            let icon = CoinMatchIcon.create(hasAd);
            homeScene.btnLayer.coinMatchIcon = icon;
            icon.posIndex = 4;
            homeScene.btnLayer.addBtnToSelf(icon, ICON_TYPE.kLeft, "kCoinMatch");
            this.resetBusy(Action.kShowIcon);
        }
        CoinMatchIcon.preloadResPromise(false)
        .then(createIcon)
        .catch((err)=> console.error("CoinMatchIcon.preloadResPromise failed.", err));
    } else {
        this.resetBusy(Action.kShowIcon);
    }

    return false;
}

/**
 * 展示领取最终大奖界面
 */
CoinMatchLogic.prototype.showFinalRewardPanel = function(onShowSuccess, onShowFail, onPanelClose, toastErr = true) {
    if (!this.canResponse(Action.kShowFinalReward)) {
        console.warn("CoinMatchLogic is too busy to show FinalRewardPanel.");
        return true;
    }

    this.setBusy(Action.kShowFinalReward);
    
    require("activity/CoinMatchActivity/CoinMatchFinalRewardPanel").show(
        onShowSuccess, 
        (err)=> {
            this.resetBusy(Action.kShowFinalReward);
            if (toastErr)
                Toast.make(CoinMatchConfig.strings.openFail);

            if (onShowFail != null) {
                onShowFail(err);
            }
        }, 
        ()=> {
            this.resetBusy(Action.kShowFinalReward);
            if (onPanelClose != null)
                onPanelClose();
    });

    return false;
}

/**
 * 展示活动
 */
CoinMatchLogic.prototype.show = function (onShowSuccess, onShowFail, onPanelClose, toastErr = true, lastLvStep) {
    if (!this.canResponse(Action.kShow)) {
        console.warn("CoinMatchLogic is too busy to show.");
        return true;
    }

    this.setBusy(Action.kShow);

    let showPoster = false;
    let showMain = ()=> {
        let CoinMatchPanel = require("activity/CoinMatchActivity/CoinMatchPanel");
        CoinMatchPanel.show(
            lastLvStep,
            showPoster? null: onShowSuccess,
            ()=> {
                this.resetBusy(Action.kShow);
                if (toastErr)
                    Toast.make(CoinMatchConfig.strings.openFail);
                if (!showPoster && onShowFail != null)
                    onShowFail();
            },
            (closeType)=> {
                this.resetBusy(Action.kShow);
                if (onPanelClose != null)
                    onPanelClose(closeType);
            });
    }
    this.manager.dealLastLevelRecord()
        .then(() => {
            this.manager.loadDataFromServer(true, showMain, ()=> this.resetBusy(Action.kShow));
        })
        .catch((error) => {
            this.resetBusy(Action.kShow);
            LogToLogCenter(error);
            Toast.make(curryQuickGetErrorText(0));
        });

    return false;
}

/**
 * 是否可以重置
 */
CoinMatchLogic.prototype.canReset = function() {
    return this.manager.getResetRemainTimes() > 0 && !this.manager.hasFinishAllLevel();
}

/**
 * 是否可以看广告加更多步数
 */
CoinMatchLogic.prototype.canGetMoreStepByAd = function() {
    return this.manager.getMoreStepsNum() < CoinMatchConfig.values.adLimit;
}

/**
 * 打开重置面板
 */
CoinMatchLogic.prototype.showResetPanel = function(onShowSuccess, onShowFail, onPanelClose, toastErr = true) {
    if (!this.canResponse(Action.kShowResetPanel)) {
        console.warn("CoinMatchLogic is too busy to show ResetPanel.");
        return true;
    }
    
    this.setBusy(Action.kShowResetPanel);

    let CoinMatchResetPanel = require("activity/CoinMatchActivity/CoinMatchResetPanel");
    CoinMatchResetPanel.show(
        onShowSuccess,
        ()=> {
            this.resetBusy(Action.kShowResetPanel);
            if (toastErr)
                Toast.make(CoinMatchConfig.strings.openFail);
            if (onShowFail != null)
                onShowFail();
        },
        ()=> {
            this.resetBusy(Action.kShowResetPanel);
            if (onPanelClose != null)
                onPanelClose();
        });
}

/**
 * 打开说明面板
 */
CoinMatchLogic.prototype.showQuesPanel = function(onComplete) {
    if (!this.canResponse(Action.kShowQuesPanel)) {
        console.warn("CoinMatchLogic is too busy to show QuesPanel.");
        return true;
    }

    let complete = () => {
        this.resetBusy(Action.kShowQuesPanel);
        if (onComplete)
            onComplete();
    }

    let [QuesPanel, PanelEvent] = require("clover/panel/CommonQuesPanel");
    QuesPanel.show(
        CoinMatchConfig.strings.quesTitle, 
        CoinMatchConfig.strings.quesContent, 
        CoinMatchConfig.strings.quesSure, 
        true,
        (panel) => {
            panel.on(PanelEvent.Close, () => {
                panel.onClose();
                complete();
            });
            panel.popup(true, false);
        }, complete, complete);

    return false;
}

/**
 * 展示获得更多页面
 */
CoinMatchLogic.prototype.showGetMoreStepPanel = function (onShowSuccess, onShowFail, onPanelClose) {
    if (!this.canResponse(Action.kShowGetMoreStepPanel)) {
        console.warn("CoinMatchLogic is too busy to show GetMoreStepPanel.");
        return true;
    }

    let CoinMatchInvitePanel = require("activity/CoinMatchActivity/CoinMatchInvitePanel")
    Promise.all([
        CoinMatchInvitePanel.preloadResPromise(),
        CoinMatchManager.getInstance().getInvitedInfoFromServer()])
        .then(() => {
            let panel = CoinMatchInvitePanel.create();
            panel.on(BasePanelEvent.Close, ()=>{
                this.resetBusy(Action.kShowGetMoreStepPanel);
                if (onPanelClose != null)
                    onPanelClose();
            });
            
            if (onShowSuccess != null)  
                onShowSuccess();
            })
            .catch((err)=> {
                this.resetBusy(Action.kShowGetMoreStepPanel);
                console.error("CoinMatchInvitePanel show failed.", err);
                LogToLogCenter(err); 
                Toast.make(getText("panel.error.open.default"));

                if (onShowFail != null) {
                    onShowFail(err);
                }
            });

    return false;
}

/**
 * 获取最终奖励
 */
CoinMatchLogic.prototype.getFinalReward = function (onSuccess, onFail) {
    if (!this.canResponse(Action.kGetFinalReward)) {
        console.warn("CoinMatchLogic is too busy to get final reward.");
        return true;
    }

    this.setBusy(Action.kGetFinalReward);

    let [finalRewardType, finalRewardList] = this.manager.getFinalReward();
    this.manager.getRewardPromise(finalRewardType)
        .then(()=> {            
            this.resetBusy(Action.kGetFinalReward);
            finalRewardList.forEach((item)=> UserProp.getInstance().rewardProp(item.itemId, item.num, null, null, ModuleName.COIN_MATCH_ACTIVITY));
            DCAssist.dc4User101("battleForGold", "success_getGold", { type: finalRewardType });

            let CommonRewardPanel = require("clover/panel/CommonRewardPanel")[0];
            CommonRewardPanel.show(null, null, table([0, finalRewardList[0]]), ()=> {
                if (onSuccess != null)
                    onSuccess();
            }); 
        })
        .catch((errCode)=> {            
            this.resetBusy(Action.kGetFinalReward);
            Toast.make(curryQuickGetErrorText(errCode));
            if (onFail != null)
                onFail(errCode);
        });

    return false;
}

/**
 * 重置
 */
CoinMatchLogic.prototype.reset = function(onSuccess, onFail) {
    if (!this.canResponse(Action.kReset)) {
        console.warn("CoinMatchLogic is too busy to reset.");
        return true;
    }

    this.setBusy(Action.kReset);
    
    let videoClose = () => {
        DCAssist.dc4AdFinish("battleForGold", "watchAd_finish");
        this.manager.reset(
            ()=> {
                this.resetBusy(Action.kReset);
                if (onSuccess != null)
                    onSuccess();
            },
            ()=> {
                this.resetBusy(Action.kReset);
                Toast.make(CoinMatchConfig.strings.resetSuccess);
                if (onFail != null)
                    onFail();
            });
    }

    let videoQuit = ()=> {
        this.resetBusy(Action.kReset);         
        DCAssist.dc4AdDropOut("battleForGold", "watchAd_dropout");        
        Toast.make(CoinMatchConfig.strings.resetAdQuit);

        if (onFail)
            onFail();
    }

    let videoError = (err)=> {
        this.resetBusy(Action.kReset); 
        DCAssist.dc4AdNoMore("battleForGold", "watchAd_noAds")

        if (onFail)
            onFail();
    }

    playVideo(videoClose, videoQuit, videoError);
    return false;
}

/**
 * 缓存分享信息
 */
CoinMatchLogic.prototype.stashShareData = function(data) {
    this.shareData = data;
}

/**
 * 取出分享信息
 */
CoinMatchLogic.prototype.popShareData = function() {
    let data = this.shareData;
    this.shareData = null;
    return data;
}

/**
 * 处理点击分享
 */
CoinMatchLogic.prototype.processShareData = function(shareData) {
    if (shareData.shareType) {
        let http = AddStepWxGroupShareClickShare.new();
        http.addEventListener(Events.kComplete, () => Toast.make(getText("coin.match.share.success")));
        http.addEventListener(Events.kError, (evt) => Toast.make(quickGetErrorText(evt.data, getText("coin.match.share.fail"))));
        http.load(shareData);
        return
    }
    if (!shareData.isShowOff) {
        let http = CoinMatchHelpAddTimesHttp.new();
        http.addEventListener(Events.kComplete, () => Toast.make(getText("coin.match.share.success")));
        http.addEventListener(Events.kError, (evt) => Toast.make(quickGetErrorText(evt.data, getText("coin.match.share.fail"))));
        http.load(shareData.inviteCode);
    }
}

/**
 * 获取邀请好友奖励
 */
CoinMatchLogic.prototype.getInviteReward = function (index, onSuccess, onFail, onComplete, showToast = true) {
    if (!this.canResponse(Action.kGetInviteReward)) {
        console.warn("CoinMatchLogic is too busy to get invite reward.");
        return true;
    }

    this.setBusy(Action.kGetInviteReward);
    
    this.manager.getInviteRewardPromise(index)
        .then(()=> {            
            this.resetBusy(Action.kGetInviteReward);

            if (showToast)
                Toast.make(CoinMatchConfig.strings.inviteStepSuccess, 2);

            if(onSuccess != null) 
                onSuccess();
            if (onComplete != null)
                onComplete(true);
        })
        .catch((errCode)=> {            
            this.resetBusy(Action.kGetInviteReward);
            if (showToast)
                Toast.make(curryQuickGetErrorText(errCode), 1);
            if (onFail != null)
                onFail(errCode);
            if (onComplete != null)
                onComplete(false);
        });

    return false;
}

/**
 * 发送好友邀请
 */
CoinMatchLogic.prototype.inviteShare = function (onSuccess, onFail) {
    var self = this;
    if (!self.canResponse(Action.kInvite)) {
        console.warn("CoinMatchLogic is too busy to invite friend.");
        return true;
    }

    self.setBusy(Action.kInvite);
    
    let success = ()=> {
        self.resetBusy(Action.kInvite);
        onSuccess && onSuccess();
    }
    let fail = ()=> {
        self.resetBusy(Action.kInvite);
        Toast.make(getText("activity.sharefailed"));
        onFail && onFail();
    }

    ShareUtil.clickCoinMatchAskHelp(success, fail, fail);
    return false;
}

/**
 * 看广告加步数
 */
CoinMatchLogic.prototype.adForMoreStep = function (adType, onSuccess, onFail) {
    if (!this.canResponse(Action.kAd)) {
        console.warn("CoinMatchLogic is too busy to get more by ad.");
        return true;
    }

    let self = this;

    this.setBusy(Action.kAd);
    
    let videoClose = () => {
        DCAssist.dc4AdFinish("battleForGold", adType == AdType.kMoreStep ?  "ad_add_step_finish": "ad_level_finish");

        this.manager.watchAd(adType,
            (addStep) => {
                this.resetBusy(Action.kAd);    
                Toast.make(CoinMatchConfig.strings.adStepSuccess);

                let homeScene = require("clover/scene/HomeScene").getInstance();
                var icon = homeScene.btnLayer.coinMatchIcon;
                if (icon != null){
                    icon.showAdDot = self.canGetMoreStepByAd();
                    icon.update();
                }

                if (onSuccess != null)
                    onSuccess(addStep);
            }, 
            (errCode) => {
                this.resetBusy(Action.kAd);
                Toast.make(curryQuickGetErrorText(errCode));
                if (onFail != null)
                    onFail(errCode);
            }
        );
    }
    let videoQuit = ()=> {
        this.resetBusy(Action.kAd); 

        DCAssist.dc4AdDropOut("battleForGold", adType == AdType.kMoreStep ? "ad_add_step_quit" : "ad_level_quit");

        Toast.make(CoinMatchConfig.strings.adQuit);

        if (onFail)
            onFail();
    }

    let videoError = (err)=> {
        this.resetBusy(Action.kAd); 

        if (window.logCenter)
            window.logCenter.log({ message: "wx_video_ad coin-match onResetVideoAdError" + JSON.stringify(err) });
        else
            cc.error("wx_video_ad coin-match onResetVideoAdError: " + err.errMsg);
        
        DCAssist.dc4AdNoMore("battleForGold", adType == AdType.kMoreStep ? "ad_add_step_noAds" : "ad_level_noAds");

        if (onFail)
            onFail();
    }
    
    playVideo(videoClose, videoQuit, videoError, adType);
        
    return false;
}

CoinMatchLogic.prototype.playLevel = function(onSuccess, onFail, startHack) {
    let self = this;
    if (!self.canResponse(Action.kPlayLevel)) {
        console.warn("CoinMatchLogic is too busy to play level.");
        return true;
    }

    self.setBusy(Action.kPlayLevel);
    
    const maskTag = "coinMatchPlayLevel";

    let fail = ()=> {
        hideGlobalMask(maskTag);
        self.resetBusy(Action.kPlayLevel);
        if (onFail != null)
            onFail();
    }

    let realStartLevel = ()=> {  
        showGlobalMask(maskTag);
        let levelId = self.manager.getLevelId();
        let [logic, errCode] = require("activity/CoinMatchActivity/startEndLevelLogic/StartCoinMatchLevelLogic").create(levelId);
        if (logic == null) {
            fail();
        } else {
            logic.start(
                ()=> {
                    hideGlobalMask(maskTag);
                    self.resetBusy(Action.kPlayLevel);
                    if (onSuccess != null)
                        onSuccess();
                }, 
                fail);
        }
    }

    let startLevel = startHack == null? realStartLevel: ()=> {
        showGlobalMask(maskTag);
        startHack(realStartLevel);
    } 

    let checkLeftStep = ()=> {
        let leftStep = self.manager.getLeftStep();
        var doCheck = function(){
            if (leftStep <= CoinMatchConfig.values.stepLack) { 
                let data = {};
                Object.assign(data, CoinMatchConfig.confirm);          
                data.onShowFail = ()=> fail;
                data.onSure = ()=> {
                    fail();
                    self.showGetMoreStepPanel();
                };
                data.onClose = fail;
                data.onEnter = ()=> hideGlobalMask(maskTag);
                if (leftStep == 0) {
                    Object.assign(data, CoinMatchConfig.stepZero);
                    data.content = CoinMatchConfig.strings.stepZero;
                } else {
                    Object.assign(data, CoinMatchConfig.stepLack);
                    data.content = CoinMatchConfig.strings.stepLack;             
                    data.onCancel = startLevel;     
                }
                
                CommonConfirmPanel.show(data);
            } else {
                startLevel();
            }
        }
        if (window.mini && mini.getPlatform() == MiniPlatform.tt){
            var ttCanShare = SnsProxy.getInstance().curVerCanShare();
            if (ttCanShare){
                doCheck();
            }else if(leftStep > 0){
                startLevel();
            }else{
                fail();
                Toast.make("剩余步数不够啦，看视频来获取更多步数吧");
            }
        }else{
            doCheck();
        }
    }

    showGlobalMask(maskTag);
    self.manager.dealLastLevelRecord()
        .then(checkLeftStep)
        .catch((err) => {
            console.error("CoinMatchLogic startLevel failed.", err);
            fail();
        });

    return false;
}

/**
 * 炫耀
 */
CoinMatchLogic.prototype.showOff = function(onSuccess, onFail) {
    var self = this;
    if (!this.canResponse(Action.kShowOff)) {
        console.warn("CoinMatchLogic is too busy to show off.");
        return true;
    }

    this.setBusy(Action.kShowOff);
    let success = ()=> {
        this.resetBusy(Action.kShowOff);
        if (onSuccess != null)
            onSuccess();
    }
    let fail = ()=> {
        this.resetBusy(Action.kShowOff);
        if (onFail != null)
            onFail();
    }
    ShareUtil.clickCoinMatchShowOff(success, fail, fail)

    return false;
}

function playVideo(onVideoClose, onVideoQuit, onVideoError, adType) {
    var rewardAdName = "CoinMatchFailAddStep";
    if (typeof adType == "undefined"){
        rewardAdName = "CoinMatchReset";
    }
    if (adType == AdType.kMoreStep){
        rewardAdName = "CoinMatchAddStep";
    }
    let snsProxy = require("clover/sns/SnsProxy").getInstance();
    snsProxy.showAd(rewardAdName)
    .then(isEnd=> {
        if (isEnd)
            onVideoClose();
        else
            onVideoQuit();
    },(err)=>{
        if (err && err.errMsg){
            Toast.make(err.errMsg)
        }else{
            Toast.make(getText("video.ad.error"));
        }
        onVideoError(err);
    })
    .catch(err=> {
        Toast.make(getText("video.ad.error"));
        onVideoError(err);
    })
}

_instance = CoinMatchLogic.create()
module.exports = _instance